import css from '@emotion/css';
import styled from '@emotion/styled';
import { borderRadii, breakpoints } from 'app/spacing';

export const InfoModalContents = styled.div`
  display: flex;
  flex-direction: column;
  ${({ loading }) => loading && `min-height: 100px;`}

  ${({ isScrollableTable }) =>
    isScrollableTable &&
    css`
      overflow: hidden;
      border: 1px solid var(--color-border-medium);
      border-radius: ${borderRadii.small};
    `}

${({ isActivities }) =>
    isActivities &&
    css`
      width: 100%;
      min-height: 0;
      max-height: calc(100vh - 200px);
      @media (max-width: ${breakpoints.lg}px) {
        border: none;
      }
    `}
`;
